import React from 'react';
import PublicCmsPage from 'components/PublicCmsPage';

const AboutUs = () => {
  return <PublicCmsPage />;
};

export default AboutUs;
